import React, { useEffect, useState } from "react";
import { Flex, Text, Button, Badge, Box, Container, Heading } from "@radix-ui/themes";

declare global {
  interface Window {
    google?: any;
  }
}

const GooglePlayground: React.FC = () => {
  const [jwt, setJwt] = useState('empty');
  const [subject, setSubject] = useState('empty');

  useEffect(() => {
    const handleCredentialResponse = (response: any) => {
      console.log('Google Credential Response:', response);
      const id_token = response.credential;
      setJwt(id_token);

      const decoded = JSON.parse(atob(id_token.split('.')[1]));
      setSubject(decoded.sub);
    };

    if (window.google) {
      window.google.accounts.id.initialize({
        client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
        callback: handleCredentialResponse
      });

      window.google.accounts.id.renderButton(
        document.getElementById("playgroundSignInDiv"),
        { theme: "outline", size: "large", type: "standard" }
      );
    }
  }, []);

  return (
    <Box>
      <Container size="3" px="6" py="9">
        <Heading weight="bold" size="9">Live Football On TV.</Heading>
        <Flex direction="column" gap="2" py="4" justify="between">

          <Heading size="6">Google Sign-In Token Generator</Heading>
          <div id="playgroundSignInDiv"></div>

          <Flex direction="row" py="4">
            <Box style={{ maxWidth: '880px' }}><Text size="2">Full Google JWT: </Text>
              <Badge color="green" radius="none" style={{
                wordBreak: 'break-all',
                whiteSpace: 'normal',
              }}>{jwt}</Badge></Box>
          </Flex>
          <Flex direction="row">
            <Text size="2">Subject: </Text> 	<Badge color="green">{subject}</Badge>
          </Flex>
        </Flex>
      </Container>
    </Box>
  );
};

export default GooglePlayground;